import { encrypted, decrypted } from 'config/crypto';

export const setLocalStorageValue = (key, value) => localStorage.setItem(key, encrypted(value));;

export const getLocalStorageValue = (key) => localStorage.getItem(key) && decrypted(localStorage.getItem(key));

export function generateTimeSlots(start, end, interval) {
  const times = [];
  let [startHour, startMin, startPeriod] = start.match(/(\d+):(\d+) (\w+)/).slice(1);
  let [endHour, endMin, endPeriod] = end.match(/(\d+):(\d+) (\w+)/).slice(1);

  startHour = parseInt(startHour) % 12 + (startPeriod === "PM" ? 12 : 0);
  endHour = parseInt(endHour) % 12 + (endPeriod === "PM" ? 12 : 0);
  startMin = parseInt(startMin);
  endMin = parseInt(endMin);

  let current = new Date(2000, 0, 1, startHour, startMin);
  const endTime = new Date(2000, 0, 1, endHour, endMin);

  while (current <= endTime) {
    let hours = current.getHours();
    let minutes = current.getMinutes();
    let period = hours >= 12 ? "PM" : "AM";
    let displayHour = hours % 12 === 0 ? 12 : hours % 12;
    let displayMin = minutes.toString().padStart(2, "0");

    times.push(`${displayHour}:${displayMin} ${period}`);

    current.setMinutes(current.getMinutes() + interval);
  }

  return times;
}

export function formatDateToYYYYMMDD(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function isKeyurSite() {
  return window.location.host === "keyur-test.web.app" || getLocalStorageValue("RSAclient-id") === "317"
}

export function addDefaultGtag(gtmId) {
  const defaultGtag = document.createElement("script");
  defaultGtag.async = true;
  defaultGtag.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  document.head.appendChild(defaultGtag);

  const defaultGtagInline = document.createElement("script");
  defaultGtagInline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "${gtmId}");
  `;
  document.head.appendChild(defaultGtagInline);
}